import { render, staticRenderFns } from "./crudImportEditor.vue?vue&type=template&id=4926bd50&"
import script from "./crudImportEditor.vue?vue&type=script&lang=js&"
export * from "./crudImportEditor.vue?vue&type=script&lang=js&"
import style0 from "./crudImportEditor.vue?vue&type=style&index=0&id=4926bd50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports